module.exports = __webpack_public_path__ + "static/media/9.52cd5404.jpg";